export const MessagesAnswers = {
  Id: 'Identifier',
  Message: 'Message',
  DateAnswer: 'Date of answer',
  DatePreview: 'Date of preview',
  DateRead: 'Date read',
  AnswerName: 'Answer',
  AnswerValues: 'Answer values',
};
